<div class="p-3 relative">
  <div class="page-title d-flex justify-content-between align-items-center px-1 mb-3">
    <h3>FAQ Management</h3>
    <p-button
          styleClass="text-center d-flex align-items-center justify-content-center"
          class="primary-btn"
          (onClick)="addGroup()">
          <i class="pi pi-plus"></i> Add New Group
        </p-button>
  </div>

  <div class="faq-block-holder">
    <div class="row">

      <!-- GROUP LOOP -->
      <div class="col-md-6 mb-4" *ngFor="let group of groups; let gi = index" #groupCard>
        <div class="card">
          <div class="card-body pt-0 pb-0">

            <!-- GROUP HEADER -->
            <div class="faq-header d-flex align-items-center justify-content-between gap-2">

              <!-- TITLE OR INPUT -->
              <div class="flex-grow-1">
                <input
                  type="text"
                  id="group-title-{{gi}}"
                  pInputText
                  placeholder="Group Title"
                  [(ngModel)]="group.title"
                />
              </div>

              <!-- ACTION BUTTONS -->
              <div class="d-flex gap-2">

                <!-- <p-button 
                  label="Add FAQ" 
                  class="outline-btn"
                  (onClick)="addFaq(group)">
                </p-button> -->
                  <p-button
                    title="Save Group FAQs"
                    class="outline-btn"
                    [disabled]="(!group._id && !group.title)"
                    (onClick)="saveGroupFaqs(group)">
                    <i class="pi pi-save"></i>
                  </p-button>
                <!-- <p-button
                  class="outline-btn">
                  <i class="pi pi-save"></i>
                </p-button> -->

                <p-button 
                  *ngIf="gi >= 0" 
                  title="Delete Group"
                  class="outline-btn" 
                  (click)="showDeleteDialog(group, gi)">
                  <i class="pi pi-trash"></i>
                </p-button>

                <p-button
                  class="outline-btn"
                  (onClick)="group.collapsed = !group.collapsed">
                  <i [ngClass]="group.collapsed ? 'pi pi-angle-right' : 'pi pi-angle-down'"></i>
                </p-button>
              </div>
            </div>

            <!-- COLLAPSE BODY -->
            <div [ngClass]="{ 'collapse': group.collapsed, 'show': !group.collapsed }">
              <div class="faq-body" *ngFor="let item of group.faqs; let i = index" #faqRow>

                <!-- QUESTION ROW -->
                <div class="form-group p-0 d-flex align-items-center gap-2">
                  <input
                    type="text"
                    pInputText
                    placeholder="Question"
                    [(ngModel)]="item.question" />

                    <p-button 
                      title="Delete FAQ"
                      class="danger-btn"
                      styleClass="border-0 shadow-none" 
                      *ngIf="i >= 0" (click)="openDeleteFaqDialog(group, i)">
                      <i class="pi pi-trash"></i>
                    </p-button>
                </div>

                <!-- ANSWER ROW -->
                <div class="form-group textarea-max-height p-0">
                  <textarea
                    class="w-100"
                    rows="3"
                    pInputTextarea
                    autoResize="true"
                    placeholder="Answer"
                    [(ngModel)]="item.answer">
                  </textarea>
                </div>

                <!-- SAVE BUTTON -->
                <!-- <div class="d-flex gap-2">
                  <p-button
                    label="Save"
                    class="primary-btn"
                    [disabled]="!group._id || !item.question || !item.answer"
                    (onClick)="createOrUpdateFaqItem(group, item)">
                  </p-button>
                </div> -->

              </div>
              <!-- 🔥 SINGLE SAVE BUTTON FOR GROUP -->
              <div class="faq-footer">
                <p-button
                  title="Add FAQ"
                  class="outline-btn ms-auto mb-2" 
                  (onClick)="addFaq(group)">
                  <i class="pi pi-plus"></i>
                </p-button>

                <!-- <p-button
                  label="Save Group FAQs"
                  class="w-100 primary-btn"
                  styleClass="w-100 text-center d-flex align-items-center justify-content-center"
                  [disabled]="(!group._id && !group.title?.trim())"
                  (onClick)="saveGroupFaqs(group)">
                </p-button> -->
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ADD NEW GROUP BUTTON -->
      <div class="col-md-12" *ngIf="groups.length > 0">
        <div class="d-flex align-items-center">
          <p-button
          styleClass="text-center d-flex align-items-center justify-content-center"
          class="primary-btn ms-auto"
          (onClick)="addGroup()">
          <i class="pi pi-plus"></i> Add New Group
        </p-button>
        </div>
      </div>

    </div>
  </div>
</div>

<!-- Confirm Delete Dialog For Group-->
<div class="dlt-confirmation-dialog">
  <p-dialog 
    header="Confirm Group Delete" 
    [(visible)]="showDeleteGroupDialog" 
    modal="true" 
    [closable]="false" 
    [responsive]="true"
    [style]="{width: '350px'}">

    <div class="confirmation-content d-flex align-items-baseline gap-2">
      <i class="pi pi-exclamation-triangle text-danger"></i>
      <small>Are you sure you want to delete this Group?</small>
    </div>

    <div class="d-flex justify-content-end gap-2 mt-3">
      <p-button class="secondary-btn" (click)="cancelDelete()">
        <i class="pi pi-times"></i>
        No
      </p-button>
      <p-button class="primary-btn" (click)="confirmDelete()">
        <i class="pi pi-check"></i>
        Yes
      </p-button>
    </div>
  </p-dialog>
</div>
<!-- Confirm Delete Dialog For Group FAQs-->
<div class="dlt-confirmation-dialog">
  <p-dialog 
    header="Confirm FAQ Delete" 
    [(visible)]="showDeleteGroupFaqDialog" 
    modal="true" 
    [closable]="false" 
    [responsive]="true"
    [style]="{width: '350px'}">

    <div class="confirmation-content d-flex align-items-baseline gap-2">
      <i class="pi pi-exclamation-triangle text-danger"></i>
      <small>Are you sure you want to delete this FAQ?</small>
    </div>

    <div class="d-flex justify-content-end gap-2 mt-3">
      <p-button class="secondary-btn" (click)="cancelDeleteFaq()">
        <i class="pi pi-times"></i>
        No
      </p-button>
      <p-button class="primary-btn" (click)="confirmDeleteFaq()">
        <i class="pi pi-check"></i>
        Yes
      </p-button>
    </div>
  </p-dialog>
</div>
<p-toast></p-toast>